export const langEN = {
  // grouped translations
  error: {},
  lang: {
    indonesia: 'Indonesia',
    english: 'English',
  },

  menu: {
    candidate_management: 'CANDIDATE MANAGEMENT',
    jobs: 'JOBS',
    settings: 'SETTINGS',
    users: 'PENGGUNA',
    school_data: 'Data Sekolah',
    master_data: 'DATA MASTER',
    job_status: 'Status Pekerjaan',
    skill: 'Keahlian',
    school_name: 'Nama Sekolah',
    school_location: 'Lokasi Sekolah',
    job_position: 'Posisi',
    interview_forms: 'Interview Forms',
    offering_letter_forms: 'Offering Letter Forms',
    register: 'Register',
    login: 'Login',
    welcome_name: 'Selamat datang {{name}}!',
    hello_name: 'Hello, {{name}}',
    staff_personalia: 'Staff Personalia',
    admin: 'Admin',
    user: 'User',
    archive: 'Archive',
  },

  form: {
    foundation_name: 'Nama Yayasan',
    foundation_address: 'Alamat Yayasan',
    phone_number: 'Nomor Telepon',
    website: 'Situs Web',
    vision: 'Visi',
    mission: 'Misi',
    profile: 'Profile',
    logo: 'Logo',
    choose_file: 'Pilih File',
    saved: 'Data tersimpan',
    submitted: 'Form submitted',
    description: 'Deskripsi',
    name: 'Nama',
    search: 'Cari',
    birth_date: 'Tanggal Lahir',
    password: 'Password',
    email: 'Email',
    title: 'Posisi Pekerjaan',
    school: 'Sekolah',
    placement: 'Placement',
    location: 'Lokasi',
    job_position: 'Jenis Pekerjaan',
    status: 'Status',
    skill: 'Keahlian',
    ended_at: 'Berakhir Pada',
    minimum_salary: 'Gaji Minimal',
    maximum_salary: 'Gaji Maksimal',
    job_description: 'Deskripsi Pekerjaan',
    job_status_description: 'Job Status Description',
    step: 'Step',
    job_positions: 'Job Positions',
    select_job_positions: 'Select Job Positions',
    form_builder: 'Form Builder',
    add_page: 'Add Page',
    page: 'Page',
    untitled_page: 'Untitled Page',
    page_title: 'Page Title',
    remove_page: 'Remove Page',
    questions: 'Questions',
    add_question: 'Add Question',
    collapse_all: 'Collapse All',
    expand_all: 'Expand All',
    question: 'Question',
    question_type: 'Question Type',
    question_category: 'Question Category',
    question_text: 'Question Text',
    enter_question_text: 'Enter question text',
    required: 'Required',
    options: 'Options',
    add_option: 'Add Option',
    option: 'Option',
    remove: 'Remove',
    visibility_logic: 'Visibility Logic',
    logic_functionality_will_be_implemented_here: 'Logic functionality will be implemented here',
    no_questions_added_yet: 'No questions added yet',
    add_first_question: 'Add First Question',
    rating_options: 'Rating Range',
    file_options: 'File Upload Settings',
    checkbox_options: 'Checkbox Options',
    radio_options: 'Radio Button Options',
    dropdown_options: 'Dropdown Options',
    options: 'Options',
    add_option: 'Add Option',
    no_options_added: 'No options added yet',
    add_first_option: 'Add First Option',
    // Visibility logic conditions
    condition_empty: 'Empty',
    condition_not_empty: 'Not Empty',
    condition_equal: 'Equal To',
    condition_not_equal: 'Not Equal To',
    condition_any_of: 'Any Of',
    condition_greater: 'Greater Than',
    condition_less: 'Less Than',
    condition_greater_or_equal: 'Greater Than or Equal',
    condition_less_or_equal: 'Less Than or Equal',
    // File upload
    upload_multiple_files: 'Upload Multiple Files',
    allowed_file_extensions: 'Allowed File Extensions',
    file_upload_condition_hint: 'File upload condition - no value needed',
    // Placeholders
    enter_option_value: 'Enter option value...',
    enter_number: 'Enter number...',
    enter_value: 'Enter value...',
    option_number: 'Option',
    other_option: 'Other Option',
    question_number: 'Question',
    questions_will_be_added_here: 'Questions will be added here',
    create_interview_form: 'Create Interview Form',
    edit_interview_form: 'Edit Interview Form',
    create_offering_letter_form: 'Create Offering Letter Form',
    edit_offering_letter_form: 'Edit Offering Letter Form',
    add_visibility_logic: 'Add Visibility Logic',
    visibility_logic: 'Visibility Logic',
    remove_logic: 'Remove Logic',
    show_question_when: 'Show this question when:',
    select_question: 'Select a question...',
    condition: 'Condition:',
    value: 'Value:',
    action: 'Action:',
    show_this_question: 'Show this question',
    hide_this_question: 'Hide this question',
    logic_help_text: 'This question will be {{action}} when the condition is met.',
    min_rating: 'Min Rating',
    max_rating: 'Max Rating',
    file_extensions_help: 'Separate with commas. Example: .jpg, .png, .pdf, .doc, .xls',
    options_note: 'Note: The value is automatically set to match the label for simplicity.',
    form_preview: 'Form Preview',
    interview_form: 'Interview Form',
    no_survey_data: 'No survey data provided',
    no_preview_data: 'No preview data available',
    no_pages_added_yet: 'No pages added yet',
    add_first_page: 'Add First Page',
    no_data_found: 'No data found',
    refresh: 'Refresh',
    skill_description: 'Skill Description',
    qualification: 'Kualifikasi',
    required_skill: 'Keahlian Wajib',
    religion: 'Agama',
    choose_pic: 'Pilih Gambar',
    max_size_pic: 'Maksimal {{size}} MB',
    choose_profile_pic: 'Pilih Foto Profile',
    allowed_pic_file: 'Tipe file yang di perbolehkan',
    fullname: 'Nama Lengkap',
    nickname: 'Nama Panggilan',
    nik: 'National ID Number',
    // Question types
    question_type_text: 'Text',
    question_type_date: 'Date',
    question_type_datetime: 'DateTime',
    question_type_number: 'Number',
    question_type_rating: 'Rating',
    question_type_checkbox: 'Checkbox',
    question_type_radiogroup: 'Radio Group',
    question_type_dropdown: 'Dropdown',
    question_type_file: 'File',
    // Question categories
    question_category_competency: 'Competency',
    question_category_organizational_fit: 'Organizational Fit',
    // Rating stars
    star_singular: 'Star',
    star_plural: 'Stars',
    remove_option: 'Remove option',
    no_hp: 'No. HP',
    nomor_hp: 'Nomor HP',
    alt_no_telp: 'Alternatif No. TLP',
    email_address: 'Alamat Email',
    social_media: 'Sosial Media',
    gender: 'Jenis Kelamin',
    weight: 'Berat Badan',
    height: 'Tinggi Badan',
    blood_type: 'Golongan Darah',
    birth_place_date: 'Tempat/Tanggal Lahir',
    religion: 'Agama',
    ethnic: 'Suku Bangsa',
    married_status: 'Status Perkawinan',
    total_child: 'Jumlah Anak',
    upload_cv: 'Upload CV',
    upload_ktp: 'Upload KTP',
    upload_npwp: 'Upload NPWP',
    upload_ijazah: 'Upload Ijazah & Transkrip Nilai Terakhir',
    upload_paklaring: 'Upload Surat Keterangan Kerja',
    upload_sk_domisili: 'Upload Surat Keterangan Domisili',
    upload_skck: 'Upload SKCK',
    upload_pas_photo: 'Upload Pas Foto 3x4',
    upload_bank_account: 'Upload Nomor Rekening Bank NISP',
    upload_kk: 'Upload Kartu Keluarga',
    upload_medical_checkup: 'Upload Medical Checkup',
    birth_place: 'Tempat Lahir',
    birth_date: 'Tanggal Lahir',
    stage: 'Stage',
    reason: 'Reason',
    choose_stage: 'Choose Stage',
    edit_password: 'Ubah Password',
    edit_email: 'Ubah Email',
    new_email: 'Email Baru',
    old_password: 'Password Lama',
    new_password: 'Password Baru',
    password_confirmation: 'Konfirmasi Password',
    academic_title: 'Gelar',
    variable_bank: 'Variable Bank',
    select_variable_to_insert: 'Select a variable to insert into the text',
    insert_variable: 'Insert Variable',
    variables: 'Variables',
  },

  button: {
    login: 'Masuk',
    register: 'Daftar',
    learn_more: 'Learn More',
    send_verification_link: 'Send Verification Link',
    send: 'Kirim',
    save: 'Simpan',
    update: 'Ubah',
    cancel: 'Batal',
    submit: 'Submit',
    save_logo: 'Simpan Logo',
    add_new: 'Tambah Baru',
    delete: 'Hapus',
    reset: 'Reset',
    reset_password: 'Reset Password',
    search: 'Cari',
    filter: 'Filter',
    archive: 'Arsipkan',
    preview: 'Preview',
    apply: 'Lamar',
    share: 'Bagikan',
    detail: 'Detail',
    see: 'Lihat',
    login: 'Masuk',
    create_new_account: 'Buat Akun Baru',
    upload: 'Upload',
    stage: 'Stage',
    reject: 'Reject',
    download: 'Download',
    send_task: 'Send Task',
    send_message: 'Send Message',
    edit: 'Ubah',
    yes: 'Ya',
    no: 'Tidak',
    export: 'Ekspor',
    edit_password: 'Ubah Password',
    edit_email: 'Ubah Email',
    activate: 'Aktifkan',
    previous: 'Kembali',
    next: 'Next',
    continue: 'Continue',
    hire: 'Hire',
    send_offer: 'Send Offer',
    close: 'Close',
  },

  profile_tab: {
    profile: 'Identitas Pribadi',
    family: 'Keluarga',
    experience: 'Pendidikan & Pekerjaan',
    health: 'Riwayat Kesahatan',
    interest: 'Peminatan',
    other: 'Informasi Lain',
    reference: 'Referensi & Pernyataan',
    document: 'Dokumen',
    document_list: 'Daftar Dokumen',
  },

  stage: {
    received: 'Application Received',
    send_task: 'Send Task',
    task_sent: 'Task Sent',
    rejected: 'Rejected',
    declined: 'Declined',
    for_interview: 'For Interview',
    induction: 'Induction',
    offered: 'Offered',
    hired: 'Hired',
    application_sent: 'Application Sent',
    task_received: 'Task Received',
    interview_scheduled: 'Interview Scheduled',
    offering: 'Offering',
    for_test: 'For Test',
    administration: 'Administration',
    input_offer: 'Input Offer',
  },

  application: {
    offered_amount: 'Offered salary',
    offer_sent: 'Offer sent',
  },

  role: {
    superadmin: 'Superadmin',
    admin: 'Admin',
    candidate: 'Candidate',
  },

  sosmed: {
    ig: 'Instagram',
    tw: 'Twitter',
    fb: 'Facebook',
    yt: 'Youtube',
  },

  gender: {
    f: 'Wanita',
    m: 'Pria',
  },

  http: {
    request_failed: 'Request failed. there something wrong',
  },

  toast: {},

  passwords: {
    sent: 'Email sent',
    reset: 'Password has been reset',
    throttled: 'Please wait before tyring again',
    token: 'Invalid password reset token',
    user: 'User not found',
  },

  files: {
    ktp: 'KTP',
    npwp: 'NPWP',
    ijazah: 'Ijazah & Transkrip Nilai Terakhir',
    paklaring: 'Surat Keterangan Kerja',
    sk_domisili: 'Surat Keterangan Domisili',
    skck: 'SKCK',
    pas_photo: 'Pas Foto 3x4',
    kk: 'Kartu Keluarga',
    bank_account: 'Nomor Rekening Bank NISP',
    medical_checkup: 'Pemeriksaan Medis',
  },

  date: {
    date: 'Date',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    days: 'Days',
    months: 'Months',
    years: 'Years',
  },

  // general translations
  name: 'Name',
  last_login: 'Last login',
  birthday: 'Birthday',
  full_name: 'Full name',
  first_name: 'First name',
  last_name: 'Last name',
  username: 'Username',
  email: 'Email',
  phone: 'Phone',
  password: 'Password',
  password_confirmation: 'Password Confirmation',
  forgot_password: 'Forgot Password?',
  forgot_password_instruction: 'Enter your email and follow the instructions to reset your password',
  login_as: 'Login As',
  login_success: 'Login Success',
  login_failed: 'Login Failed',
  register_success: 'Register Success',
  register_failed: 'Register Failed',
  description: 'Description',
  add_new: 'Tambah Baru',
  update: 'Ubah',
  delete: 'Hapus',
  saved: 'Tersimpan',
  other_jobs: 'Lowongan Pekerjaan Lain',
  link_copied: 'Link Copied!',
  see_all_jobs: 'Lihat Semua Lowongan Kerja',
  or: 'Atau',
  login_failed: 'Login Failed',
  login_success: 'Login Success',
  update_profile: 'Update Profile',
  location: 'Lokasi',
  contact: 'Kontak',
  website: 'Website',
  vision: 'Visi',
  mission: 'Misi',
  profile: 'PROFILE {{name}}',
  apply_for: 'Apply For',
  reject: 'Reject',
  send_task: 'Send Task',
  reset_password: 'Reset Password',
  edit: 'Ubah',
  page: 'Halaman',
  from: 'dari',
  are_you_sure_to_logout: 'Apakah anda yakin ingin keluar?',
  logout_success: 'Logout Success',
  reason: 'Reason',
  archived: 'Archived',
  hire: 'Hire',
  are_you_sure: 'Are you sure?',
  confirmation: 'Confirmation',
  time: 'Time',
  place: 'Place',
  induction_date: 'Induction Date',
  induction_notes: 'Induction Notes',
  interview_date: 'Interview Date',
  interview_notes: 'Interview Notes',
  interview_reschedule_date: 'Interview Reschedule Date',
  interview_reschedule_request: 'Cannot attend interview on',
  waiting_interview_reschedule: 'Waiting for interview reschedule',
  rejection_reason: 'Reason for rejection',
  offered_status: 'Status Penerimaan',
  accept: 'Ya',
  decline: 'Tidak',
  reason: 'Reason',
  reason_reject: 'Alasan Penolakan Interview',
  reason_reschedule: 'Alasan Ganti Jadwal Interview',
  cannot_empty: ' cannot be empty',
  times_applied: 'Times Applied',
  offering: 'Offering',
  offer_amount: 'Offer Amount',
  job_level: 'Job Level',
  position: 'Position',
  position_alt: 'Job Position',
  Unit: 'Unit',
  'Unit Utama': 'Main Unit',
  penempatan: 'Placement',
  tunjangan_tempat_tinggal: 'Housing Allowance',
  tanggal_training: 'Training Date',
  contract_type: 'Contract Type',
  contract_date_start: 'Start Contract Date',
  contract_date_end: 'End Contract Date',
  contract_duration: 'Contract Duration',
  salary_amount: 'Salary Amount',

  offer_deadline: 'Offer Deadline',
  character: 'Character',
  employee_application_submission: 'Employee Application Submission',
  loading: 'Loading...',
  active: 'Active',
  inactive: 'Inactive',
  
  // Modal translations
  modal_title_candidate_detail_all_stages: 'Candidate Detail - All Stages',
  information_application: 'Application Information',
  subtitle_application_data: 'Complete data of application receipt',
  candidate_name: 'Candidate Name',
  job_position_label: 'Job Position',
  job_posting: 'Job Posting',
  application_time: 'Application Time',
  subtitle_application_time: 'Information about application submission time',
  status_ok: 'OK',
  application_received_by_system: 'Application received by the system',
  candidate_not_entered_interview_stage: 'Candidate has not entered the interview stage.',
  no_interview_schedule: 'No interview schedule',
  interview_label: 'Interview',
  interview_detail: 'Interview Detail',
  interview_form_tab: 'Interview Form',
  interview_information: 'Interview Information',
  interview_type: 'Interview Type',
  interview_type_online: 'Online',
  interview_type_offline: 'Offline',
  interview_stage: 'Interview Stage',
  interviewer_name: 'Interviewer Name',
  interview_date: 'Interview Date',
  interview_time: 'Interview Time',
  interview_link: 'Interview Link',
  interview_place: 'Interview Place',
  interview_status: 'Interview Status',
  interview_score: 'Interview Score',
  interview_form: 'Interview Form',
  interview_form_answers: 'Interview form answers',
  no_interview_form_assigned: 'Interview form has not been assigned for this interview',
  interviewer_notes: 'Interviewer Notes',
  interviewer_label: 'Interviewer',
  candidate_not_received_offer: 'Candidate has not received an offer.',
  offer_status: 'Offer Status',
  response_time: 'Response Time',
  offer_date_given: 'Offer Date Given',
  offer_data_incomplete: 'Offer data is incomplete. Please fill in the offer form first.',
  administration_stage: 'Administration Stage',
  candidate_in_administration_process: 'Candidate is currently in the administration process.',
  candidate_not_entered_administration_stage: 'Candidate has not entered the administration stage.',
  administration_documents: 'Administration Documents',
  no_administration_documents: 'No administration documents',
  download_files: 'Download Files',
  candidate_not_entered_induction_stage: 'Candidate has not entered the induction stage.',
  no_induction_schedule: 'No induction schedule',
  induction_schedule_detail: 'Induction Schedule Detail',
  induction_type: 'Induction Type',
  induction_name: 'Induction Name',
  date: 'Date',
  time: 'Time',
  location: 'Location',
  induction_guide: 'Induction Guide',
  notes: 'Notes',
  status: 'Status',
  accepted: 'Accepted',
  rejected: 'Rejected',
  pending_confirmation: 'Pending Confirmation',
  rejection_reason: 'Reason for Rejection',
  contract_detail: 'Contract Detail',
  candidate_not_contracted: 'Candidate has not been contracted.',
  rejection_status: 'Rejection Status',
  rejection_information: 'Detailed information about candidate rejection',
  date_not_recorded: 'Date not recorded',
  candidate_rejected: 'Candidate rejected',
  no_reason_recorded: 'No reason recorded',
  offer_rejection_status: 'Offer Rejection Status',
  offer_rejection_information: 'Information about offer rejection from candidate',
  candidate_rejected_offer: 'Candidate rejected the offer',
  stage_content_unavailable: 'Stage content is not available',
  badge_current: 'Current',
  unknown: 'Unknown',
  position_label: 'Position:',
  posting_label: 'Posting:',
  school_label: 'School:',
  timeline: 'Timeline',
  loading_job_positions: 'Loading job positions...',
  per_page: 'Per Page',
  date_label: 'Date',
  mark_as_read: 'Mark as Read',
  unread: 'Unread',
  read: 'Read',
  mark_all_as_read: 'Mark All as Read',
  mark_all_as_read_confirm: 'Are you sure you want to mark all notifications as read?',
  notification_empty: 'No notifications',
  confirm: 'Confirm',
  cancel: 'Cancel',
  contract_information_label: 'Contract Information Details',
  contract_status: 'Contract Status',
  hired_confirmation: 'Hiring Confirmation',
  hired_status: 'Hired / Contracted',
  employment_confirmation: 'Employment Confirmation',
  candidate_successfully_hired: 'Candidate Successfully Hired',
  congratulations_hired: 'Congratulations! You Have Been Hired',
  welcome_to_team: 'Welcome to our team!',
};

export default langEN;
